"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voltage = void 0;
exports.voltage = {
    router: '0xE3F85aAd0c8DD7337427B9dF5d0fB741d65EEEB5',
    masterchef: '0xE3e184a7b75D0Ae6E17B58F5283b91B4E0A2604F',
};
